export default __webpack_public_path__ + "static/included-2-3b41f972b0ebb46d37b96e6db2a4810d.png";